export const MARKER_TYPE = {
  exact    : {
    src     : '//search1.daumcdn.net/search/statics/common/pi/map/mark_place_bot1_170209.png',
    w       : 39,
    h       : 41,
    x       : 15,
    y       : 44,
    z_index : 3,
  },
  normal   : {
    src : '//search1.daumcdn.net/search/statics/common/pi/map/mark_map#_170209.png',
    w   : 30,
    h   : 34,
    x   : 10,
    y   : 34
  },
  lineDot  : {
    src : '//search1.daumcdn.net/search/statics/common/pi/map/point_place_bot_170209.png',
    w   : 12,
    h   : 12,
    x   : 10,
    y   : 12
  },
  premium  : {
    src : '//search1.daumcdn.net/search/statics/common/pi/map/mark_ad#_170209.png',
    w   : 30,
    h   : 34,
    x   : 10,
    y   : 34
  },
  tilePlus : {
    src : '//search1.daumcdn.net/search/statics/common/pi/map/point_ad_170209.png',
    w   : 10,
    h   : 10,
    x   : 4,
    y   : 3
  }
};

export const LINE_TYPE = {
  ACTIVE    : {
    strokeColor   : '#D9025C',
    strokeWeight  : 4,
    strokeOpacity : 0.8
  },
  DE_ACTIVE : {
    strokeColor   : '#FE378A',
    strokeWeight  : 3,
    strokeOpacity : 0.5
  }
};

export const EXPAND = {
  COUNT_PER_PAGE : 5,
  START_OF_PAGE  : 1,
  END_OF_PAGE    : 4,
  FLAG_IS_END    : 'end_of_list',
};



/** WEBPACK FOOTER **
 ** ./src/local/poi/const.js
 **/